import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import { Session } from '../../session';
import { SessionService } from '../../session.service';

import { AppConst } from '../../app-const';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private sessionService: SessionService,
    private router: Router,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.sessionService.authObservable.pipe(map((session: Session) => {
      if (!session.isLogin) {
        this.router.navigate([AppConst.ROUTING_LINK_SIGN_IN]);
        return false;
      } else {
        if (session.user) {
          return true;
        } else {
          this.sessionService.logout();
          return false;
        }
      }
    }))
  }
  
}
